var React = require('react');

function Tiled (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":".64611","y":"2.4021","width":"6.5875","height":"6.0464","key":0}),React.createElement("rect",{"x":"9.114","y":"2.4021","width":"6.5875","height":"6.0464","key":1}),React.createElement("rect",{"x":"17.546","y":"2.4021","width":"6.5875","height":"6.0464","key":2}),React.createElement("rect",{"x":"9.114","y":"10.115","width":"6.5875","height":"6.0464","key":3}),React.createElement("rect",{"x":"9.114","y":"17.828","width":"6.5875","height":"6.0464","key":4})]);
}

Tiled.defaultProps = {"fill":"currentColor","stroke":"currentColor","version":"1.0","viewBox":"0 0 25 25"};

module.exports = Tiled;

Tiled.default = Tiled;
